import axios from "axios";
import { apiVariable } from "./apiVariable";
import { LogbookCheck } from "../interfaces/Fleet/ILogbookCheck";

export const fetchLogbookChecksByDriver = async (
  token: string | null | undefined,
  driverId: string,
  month?: number,
  year?: number
): Promise<LogbookCheck[]> => {
  const params: Record<string, number> = {};

  if (month) {
    params.month = month;
  }

  if (year) {
    params.year = year;
  }

  const { data } = await axios.get(
    `${apiVariable}/logbookChecks/driver/${driverId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      params,
    }
  );
  return data;
};

export const createLogbookCheck = async (
  token: string | null | undefined,
  dto: Partial<LogbookCheck>
): Promise<LogbookCheck> => {
  const { data } = await axios.post(`${apiVariable}/logbookCheck`, dto, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const updateLogbookCheck = async (
  token: string | null | undefined,
  id: string,
  dto: Partial<LogbookCheck>
): Promise<LogbookCheck> => {
  const { data } = await axios.put(`${apiVariable}/logbookCheck/${id}`, dto, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};
